const CERTIFICATE_OF_INSURANCE_DOCUMENT_TYPE = 'certificate_of_insurance'


export type Document = {
  file?: File
  type?: string  // Document type ("w9", "certificate_of_insurance", etc.).
  expirationDate?: string // Date in the format "yyyy-MM-dd" (e.g. 2026-05-31).
}


export type AttachmentDocumentTypeOption = {
  value: string
  label: string
}

export function isCertificateOfInsurance(document: Document) {
  return document.type === CERTIFICATE_OF_INSURANCE_DOCUMENT_TYPE
}

export function isDocumentValid(document: Document): boolean {
  const isCOI = isCertificateOfInsurance(document)
  if (!document.type) return false
  if (!document.file) return false
  if (isCOI && !document.expirationDate) return false
  return true;
}
